export const tableCell = {
    px: "10px",
    py: "16px",
    whiteSpace: "nowrap",
};

export const tableContainer = {
    maxHeight: 533,
    '&::-webkit-scrollbar': {
        width: '12px',
        height: '12px',
    },
    '&::-webkit-scrollbar-track': {
        backgroundColor: '#cccccc',
        borderRadius: '0',
    },
    '&::-webkit-scrollbar-thumb': {
        backgroundColor: '#888',
        borderRadius: '2px',
    },
}

export const editIcon = {
    fontSize: 16,
    p: 0,
    cursor: "pointer"
}

export const tableHeaderCell = {
    fontWeight: "600",
    whiteSpace: "nowrap",
    cursor: "pointer",

    '&:hover': {
        backgroundColor: '#2f526d',
    },
}

export const actionsCell = {
    fontWeight: "600",
    cursor: "default",
    textAlign: "center"
}

export const searchInner = {
    mb: 1,
    display: "flex",
    justifyContent: "end",
}

export const searchField = {
    '& .MuiInputBase-input': {
        padding: '7px 15px',
        height: '35px'
    }
}

export const editButton = {
    py: "3px",
    px: 0,
    border: "none",
    color: "#FFFFFF",
    width: "35px",
    minWidth: "35px",

    '&:hover': {
        backgroundColor: 'transparent',
        color: "#60aeec"
    },

    '&:focus': {
        backgroundColor: 'transparent',
        color: "#60aeec"
    },
}
